import { render } from "./BundleApplicationRoles.vue?vue&type=template&id=427c2022&scoped=true"
import script from "./BundleApplicationRoles.vue?vue&type=script&lang=js"
export * from "./BundleApplicationRoles.vue?vue&type=script&lang=js"

import "./BundleApplicationRoles.vue?vue&type=style&index=0&id=427c2022&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427c2022"]])

export default __exports__